export const convertTimeToGMTTime = (date) => {

    if(date){
        const [datePart, timePart] = date.split(" ");
  
        // Split the date part into day, month, and year
        const [day, month, year] = datePart.split("-").map(Number);
      
        // Split the time part into hours, minutes, and seconds
        const [hours, minutes, seconds] = timePart.split(":").map(Number);
        const dateObject = new Date(year, month - 1, day, hours, minutes, seconds);
        return dateObject;
    }else{
        return null;
    }

 
  };